import { useState } from "react";
import { apiAgent } from "../config/axiosConfig";

export const useS3Upload = (customConfig = {}) => {
  const [progress, setProgress] = useState(0);
  const [uploadStatus, setUploadStatus] = useState("idle");
  const [signedUrl, setSignedUrl] = useState("");

  const resetUploadStatus = () => {
    setUploadStatus("idle");
    setProgress(0);
    setSignedUrl("");
  };

  const getPresignedUrl = async () => {
    try {
      const response = await apiAgent({
        method: "get",
        url: "/api/v1/assets/upload_metadata"
      });

      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error("Failed to get presigned URL");
      }
    } catch (error) {
      console.error("Error getting presigned URL:", error);
      throw error;
    }
  };

  const uploadFile = async (file) => {
    try {
      setUploadStatus("uploading");

      // Get presigned URL data from API
      const presignedData = await getPresignedUrl();

      const formData = new FormData();

      // Add all the required fields from presignedData
      Object.entries(presignedData.params).forEach(([key, value]) => {
        // If this is the key parameter, append the filename to it
        if (key === 'key') {
          formData.append(key, `${value}${file.name}`);
        } else {
          formData.append(key, value);
        }
      });

      // Add the file with the correct key
      formData.append("file", file);

      return new Promise((resolve, reject) => {
        const xhr = new XMLHttpRequest();

        xhr.upload.addEventListener("progress", (evt) => {
          if (evt.lengthComputable) {
            setProgress(Math.round((evt.loaded / evt.total) * 100));
          }
        });

        xhr.addEventListener("load", () => {
          if (xhr.status === 201) {
            const url = `${presignedData.url}/${presignedData.params.key}${file.name}`;
            setSignedUrl(url);
            setUploadStatus("success");
            resolve({ url });
          } else {
            setUploadStatus("error");
            reject(new Error(`Upload failed with status: ${xhr.status}`));
          }
        });

        xhr.addEventListener("error", (error) => {
          setUploadStatus("error");
          console.error("Upload error:", error);
          reject(new Error("Upload failed due to network or CORS error"));
        });

        // Add CORS headers
        // xhr.withCredentials = true;
        
        xhr.open("POST", presignedData.url);
        xhr.send(formData);
      });
    } catch (error) {
      setUploadStatus("error");
      console.error("Upload error:", error);
      throw error;
    }
  };

  return { uploadFile, progress, uploadStatus, signedUrl, resetUploadStatus };
};
